<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">{{ coreConfig.app.appName }}</h2></a
    >
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/register-v2-dark.svg'
              : 'assets/images/pages/register-v2.svg'
          "
          alt="Register V2"
        />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Register-->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Adventure starts here 🚀</h2>
        <p class="card-text mb-2">Make your app membership easy and fun!</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>  

        <form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="register-customer_name" class="form-label">Company Name</label>
            <input
              type="text"
              formControlName="customer_name"
              class="form-control"
              placeholder="My Company PTY LTD"
              aria-describedby="register-customer_name"
              tabindex="1"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.customer_name.errors }"
            />
            <div *ngIf="submitted && f.customer_name.errors" class="invalid-feedback">
              <div *ngIf="f.customer_name.errors.required">Company Name is required</div>
            </div>
          </div>

          <div class="form-group">
            <label for="register-customer_website" class="form-label">Company Website</label>
            <input
              type="text"
              formControlName="customer_website"
              class="form-control"
              placeholder="example.com"
              aria-describedby="register-customer_website"
              tabindex="5"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.customer_website.errors }"
            />
            <div *ngIf="submitted && f.customer_website.errors" class="invalid-feedback">
              <div *ngIf="f.customer_website.errors.required">Company Website is required</div>
            </div>
          </div>

          <div class="form-group">
            <label for="register-user_firstName" class="form-label">Contact Name</label>
            <input
              type="text"
              formControlName="user_firstName"
              class="form-control"
              placeholder="John"
              aria-describedby="register-user_firstName"
              tabindex="6"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.user_firstName.errors }"
            />
            <div *ngIf="submitted && f.user_firstName.errors" class="invalid-feedback">
              <div *ngIf="f.user_firstName.errors.required">First Name is required</div>
            </div>
          </div>

          <div class="form-group">
            <label for="register-user_email" class="form-label">Email</label>
            <input
              type="text"
              formControlName="user_email"
              class="form-control"
              placeholder="john@example.com"
              aria-describedby="register-email"
              tabindex="8"
              [ngClass]="{ 'is-invalid': submitted && f.user_email.errors }"
            />
            <div *ngIf="submitted && f.user_email.errors" class="invalid-feedback">
              <div *ngIf="f.user_email.errors.required">Email is required</div>
              <div *ngIf="f.user_email.errors.email">Email must be a valid email address</div>
            </div>
          </div>

          
          <div class="form-group">
            <label for="register-user_phone" class="form-label">Phone</label>
            <input
              type="text"
              formControlName="user_phone"
              class="form-control"
              placeholder="654 654 654"
              aria-describedby="register-user_phone"
              placeholder="0000 000 000" 
              mask="9000 000 000" 
              tabindex="9"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.user_phone.errors }"
            />
            <div *ngIf="submitted && f.user_phone.errors" class="invalid-feedback">
              <div *ngIf="f.user_phone.errors.required">Phone is required</div>
            </div>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" formControlName="checkbox" id="register-privacy-policy" tabindex="10" />
              <label class="custom-control-label" for="register-privacy-policy">
                I agree to <a href="javascript:void(0);">privacy policy & terms</a>
              </label>
            </div>
          </div>
          <div class="col-12" *ngIf="!loadingButton">
            <button class="btn btn-primary btn-block" tabindex="10" rippleEffect>Request my DEMO</button>
          </div>
          <div class="col-12" *ngIf="loadingButton">
            <button class="btn btn-outline-primary" type="button" disabled rippleEffect>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ml-25 align-middle">Sending...</span>
            </button>
          </div>
        </form>
        <p class="text-center mt-2">
          <span>Already have an account?</span
          ><a routerLink="/pages/authentication/login-v2"><span>&nbsp;Sign in instead</span></a>
        </p>
        <!-- <div class="divider my-2">
          <div class="divider-text">or</div>
        </div>
        <div class="auth-footer-btn d-flex justify-content-center">
          <a class="btn btn-facebook" href="javascript:void(0)"><i data-feather="facebook"></i></a
          ><a class="btn btn-twitter white" href="javascript:void(0)"><i data-feather="twitter"></i></a
          ><a class="btn btn-google" href="javascript:void(0)"><i data-feather="mail"></i></a
          ><a class="btn btn-github" href="javascript:void(0)"><i data-feather="github"></i></a>
        </div> -->
      </div>
    </div>
    <!-- /Register-->
  </div>
</div>
